module.exports = __webpack_public_path__ + "static/media/genisis17.ac574057.jpg";